import { round } from 'lodash-es';
import type { MapboxIMap } from '..';

const precision = 5; // up to ~1 meter precision

export const getCenter: MapboxIMap['getCenter'] = function (this: MapboxIMap) {
  const { lng, lat } = this._native.getCenter();
  return [round(lng, precision), round(lat, precision)];
};
